import { ConfirmationModal, Text, type ConfirmationModalProps } from '@shared/components';

export type UpdateToOpenForRegistrationConfirmationModalProps = Omit<
  ConfirmationModalProps,
  'title' | 'content' | 'acceptText' | 'discardText' | 'onDiscard'
>;

export default function UpdateToOpenForRegistrationConfirmationModal(
  props: Readonly<UpdateToOpenForRegistrationConfirmationModalProps>,
) {
  return (
    <ConfirmationModal
      title='ยืนยันการเปิดรับสมัคร?'
      content={
        <Text>
          คุณกำลังจะเปลี่ยนสถานะเป็น{' '}
          <Text component='span' variant='body1Semibold'>
            “เปิดรับสมัคร”
          </Text>
          <br />
          ระบบจะเปิดให้สมัครสอบได้อีกครั้งตามช่วงเวลาที่กำหนด
        </Text>
      }
      acceptText='เปิดรับสมัคร'
      discardText='ยกเลิก'
      onDiscard={props.onClose}
      {...props}
    />
  );
}
